import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './header.css';
import Logo from '../images/svg/v8logo.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleProducts = () => {
    setIsProductsOpen(!isProductsOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const isProductsActive = () => {
    return ['/blogomat360', '/chatbot360'].includes(location.pathname) ? 'active' : '';
  };

  return (
    <div className='header-main'>
      <div className='header-content'>
        <div className='col-one'>
          <div className='v8logo'>
            <Link to='/'>
              <img src={Logo} alt='v8logo' className='v8logo-svg' />
            </Link>
          </div>
        </div>

        <nav className='header-nav'>
          <button className='mobile-menu-toggle' onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to='/' className={isActive('/')} onClick={() => setIsMenuOpen(false)}>Home</Link></li>

            <li className='dropdown' onMouseEnter={() => setIsProductsOpen(true)} onMouseLeave={() => setIsProductsOpen(false)}>
              <span className={`dropdown-parent ${isProductsActive()}`} onClick={() => setIsProductsOpen(!isProductsOpen)}>
                Services <span className='dropdown-arrow'>▼</span>
              </span>
              <ul className={`dropdown-menu ${isProductsOpen ? 'show' : ''}`}>
                <li><Link to='/blogomat360' onClick={() => { setIsMenuOpen(false); setIsProductsOpen(false); }}>Blogomat 360</Link></li>
                <li><Link to='/chatbot360' onClick={() => { setIsMenuOpen(false); setIsProductsOpen(false); }}>Chatbot 360</Link></li>
              </ul>
            </li>

            <li><Link to='/blog' className={isActive('/blog')} onClick={() => setIsMenuOpen(false)}>Blog</Link></li>
            <li><Link to='/contact' className={isActive('/contact')} onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Header;
